import SearchTable from "../../../primer/Search-Table";
import React from "react";

const SearchLoans = () => {
    const scColumns = [
        {
            name: "Κωδικός Δανείου",
            field: "numbering",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ημερομηνία Έναρξης",
            field: "startDate",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Επιτόκιο %",
            field: "interestRate",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Κεφάλαιο Δανεισμού",
            field: "principal",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Υπολοιπόμενο Κεφάλαιο",
            field: "remainingPrincipal",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const searchFilters = {
        filters: [
            {
                name: "numbering",
                label: "Κωδικός Δανείου",
                type: "input",
            },
            {
                name: "amountFrom",
                label: "Κεφάλαιο από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "amountTo",
                label: "Κεφάλαιο έως",
                type: "input",
                mdWidth: 2,
            },
        ],
        actions: ["quick-edit", "delete"],
    }

    return (
        <div>
            <SearchTable
                tableName="Loans Search"
                key={"Loans Search"}
                hideYearFilter={true}
                allowToggleColumns={true}
                allowPrintResults={false}
                allowPagination={true}
                dataEndpoint={"/cash/search-loans"}
                exportFileName={"Λίστα Δανείων"}
                columns={scColumns}
                data={[]}
                filtersConfig={searchFilters}
            />
        </div>
    )
}

export default SearchLoans;
